import ClipboardJS from 'clipboard';
import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { getMtaApBasicData, hydrateApBasicData } from './helpers/basicHelper';
import { addDNoneClass, byId } from './helpers/utility';






authHelper.validate();
hydrateApBasicData();







const firebaseProjectNameInput = byId('firebaseProjectNameInput');
const packageNameInput = byId('packageNameInput');
const googleServiceJsonInput = byId('googleServiceJsonInput');
const oneSignalAppIdInput = byId('oneSignalAppIdInput');
const oneSignalApiKeyInput = byId('oneSignalApiKeyInput');
const firebaseConfigEditBtn = byId('firebaseConfigEditBtn');
const oneSignalConfigEditBtn = byId('oneSignalConfigEditBtn');





var firebaseProjectNameInput_clipboard = new ClipboardJS('#firebaseProjectNameInput_clipboard');
var packageNameInput_clipboard = new ClipboardJS('#packageNameInput_clipboard');

firebaseProjectNameInput_clipboard.on('success', function (e) {


    e.clearSelection();
    Swal.fire({
        icon: 'success',
        title: 'Firebase Project Name Copied 🥰', toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });
});
packageNameInput_clipboard.on('success', function (e) {


    e.clearSelection();
    Swal.fire({
        icon: 'success',
        title: 'Package Name Copied 🥰', toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });
});








const getWebApkDetailsFun = async () => {
    try {



        const response = await callTheApServerGet(`/basic/getWebApkDetails`);
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);

            const { googleServiceJson, oneSignalApiKey, oneSignalAppId } = res.webApkDetails;

            googleServiceJsonInput.value = googleServiceJson;
            oneSignalAppIdInput.value = oneSignalAppId;

            oneSignalApiKeyInput.value = oneSignalApiKey;




            const appUsername = getMtaApBasicData().appUsername;
            const firebaseProjectName = appUsername.replaceAll('_', '-');
            firebaseProjectNameInput.value = firebaseProjectName;

            const packageName = `com.${appUsername}.web_apk`;
            packageNameInput.value = packageName;

        }

    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }
};
getWebApkDetailsFun();

const firebaseConfigEditFun = () => {
    googleServiceJsonInput.disabled = false;
    addDNoneClass(firebaseConfigEditBtn, true);
};

firebaseConfigEditBtn.addEventListener('click', firebaseConfigEditFun);

const oneSignalConfigEditFun = () => {
    oneSignalAppIdInput.disabled = false;
    oneSignalApiKeyInput.disabled = false;
    addDNoneClass(oneSignalConfigEditBtn, true);

};

oneSignalConfigEditBtn.addEventListener('click', oneSignalConfigEditFun);







const updateWebApkDetailsFun = async () => {
    try {

        const googleServiceJson = googleServiceJsonInput.value;
        const oneSignalAppId = oneSignalAppIdInput.value;
        const oneSignalApiKey = oneSignalApiKeyInput.value;




        const parse = (str) => {
            try {
                return JSON.parse(str);
            } catch (e) {
               
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid google-services.json',
                    text: 'Invalid Json Format',

                });

                return false;
            }
        };
        const googleServiceJsonObj = parse(googleServiceJson);


        // console.log(googleServiceJsonObj.client[0].client_info.android_client_info.package_name);

        if (packageNameInput.value !== googleServiceJsonObj.client[0].client_info.android_client_info.package_name) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid google-services.json',
                text: 'Package Name Not Matching',

            });
            return false;
        }

 

        const data = {
            googleServiceJson,
            oneSignalAppId,
            oneSignalApiKey,

        };

        const response = await callTheApServerPost(`/basic/updateWebApkDetails`, { data: data });
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);

            Swal.fire({
                icon: 'success',
                title: 'Configs Updated',
                text: 'Now you can Order Web Apk',
    
            });
            setTimeout(()=>{location.reload();}, 3000);
        }

    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }
};

window.updateWebApkDetailsFun = updateWebApkDetailsFun;




function hire_primexop_fun() {
    Swal.fire({
        icon: 'info',
        title: 'Hire Primexop',
        html: `You can hire Primexop staff to generate google-services.json for you <hr>
                            They will generate following for you in just 100rs or 2usd  <ol> <li>generate google-services.json </li><li>Onesignal App ID </li><li>Onesignal Api Key </li> </ol> `,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Hire Now 😍',
        denyButtonText: `Cancel 😔`,
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            location.href = 'https://api.whatsapp.com/send?phone=919834877006&text=Hello%20sir,%20I%20want%20hire%20you%20for%20generating%20my%20firebase%20and%20Onesignal%20details';
        } else if (result.isDenied) {
            Swal.fire({
                icon: 'info',
                title: 'You can do it Self by Watching Tutorials',
                html: ` Watch Following Video Without skipping <hr> <a href="https://youtu.be/a2i17i31DMc?t=598">How to Generate google-services.json ?</a> `,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Watch Now 😘',
                denyButtonText: `Watch Later 😢`,

            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    location.href = 'https://youtu.be/a2i17i31DMc?t=598';
                } else if (result.isDenied) {
//
                }
            });
        }
    });
}

window.hire_primexop_fun = hire_primexop_fun;



